import qs from 'qs';
import { API, RPC } from '../../../constants';
import request from '../../../lib/request';

const getAll = (
  page,
  { areaManager = null, tutor = null, seniorManager = null, active = true },
  orderField,
  orderDirection
) =>
  request({
    url: API.RETE_TUTOR,
    method: 'GET',
    params: {
      page,
      filter: [
        areaManager && {
          type: 'eq',
          field: 'areaManager',
          value: areaManager,
        },
        tutor && {
          type: 'like',
          field: 'nominative',
          value: `%${tutor}%`,
        },
        seniorManager && {
          type: 'like',
          field: 'nominativeSeniorManager',
          value: `%${seniorManager}%`,
        },
        active === true && {
          type: 'in',
          field: 'state',
          values: [0, 1, 2],
        },
      ].filter(Boolean),
      'order-by': [
        {
          type: 'field',
          field: orderField || 'dataRichiesta',
          direction: orderDirection !== 'none' ? orderDirection : 'asc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getTutor = (id) =>
  request({
    url: `${API.RETE_TUTOR}/${id}`,
    method: 'GET',
  });

const postNewTutor = (data) =>
  request({
    url: API.RETE_TUTOR,
    method: 'POST',
    data,
  });

const updateTutor = (id, data) =>
  request({
    url: `${API.RETE_TUTOR}/${id}`,
    method: 'PUT',
    data,
  });

const patchTutor = (id, data) =>
  request({
    url: `${API.RETE_TUTOR}/${id}`,
    method: 'PATCH',
    data,
  });

const deleteTutor = (id) =>
  request({
    url: `${API.RETE_TUTOR}/${id}`,
    method: 'DELETE',
  });

const getTutorCardData = () =>
  request({
    url: RPC.GESTIONE_RETE_TUTOR,
    method: 'POST',
    data: {
      method: 'get_rete_tutor_card_data',
    },
  });

const updateReteTutorState = (tutorId, state) =>
  request({
    url: RPC.GESTIONE_RETE_TUTOR,
    method: 'POST',
    data: {
      method: 'update_rete_tutor_state',
      params: {
        tutorId,
        state,
      },
    },
  });

const getAllTutee = (tutorId) =>
  request({
    url: API.RETE_TUTOR_TUTEE,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'tutor',
          value: tutorId || null,
        },
      ].filter((o) => o),
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const postNewNote = (data) =>
  request({
    url: API.RETE_TUTOR_NOTE,
    method: 'POST',
    data,
  });

const getNotesByTutor = (tutorId) =>
  request({
    url: API.RETE_TUTOR_NOTE,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'reteTutor',
          value: tutorId,
        },
      ],
      'order-by': [
        {
          type: 'field',
          field: 'updatedAt',
          direction: 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getDocuments = (tutorId) =>
  request({
    url: `${RPC.RETE_TUTOR_DOCUMENTS}/${tutorId}`,
    method: 'GET',
  });

const ReteTutorService = {
  getAll,
  getTutor,
  postNewTutor,
  updateTutor,
  patchTutor,
  deleteTutor,
  getTutorCardData,
  getAllTutee,
  updateReteTutorState,
  postNewNote,
  getNotesByTutor,
  getDocuments,
};

export default ReteTutorService;



// WEBPACK FOOTER //
// ./app/shared/services/api/ReteTutor/index.js